export const GET_LEAGUE_TABLE_PERIODS = 'GET_LEAGUE_TABLE_PERIODS';
export const GET_LEAGUE_TABLE_PERIODS_SUCCESS = 'GET_LEAGUE_TABLE_PERIODS_SUCCESS';
export const GET_LEAGUE_TABLE_PERIODS_ERROR = 'GET_LEAGUE_TABLE_PERIODS_ERROR';

export const SET_LEAGUE_TABLE_PERIOD = 'SET_LEAGUE_TABLE_PERIOD';
export const RESET_LEAGUE_TABLE_PERIODS = 'RESET_LEAGUE_TABLE_PERIODS';

export const GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS = 'GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS';
export const GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_SUCCESS = 'GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_SUCCESS';
export const GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_ERROR = 'GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_ERROR';

export const SET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIOD = 'SET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIOD';
export const RESET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS = 'RESET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS';

export const GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS = 'GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS';
export const GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_SUCCESS = 'GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_SUCCESS';
export const GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_ERROR = 'GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_ERROR';

export const SET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIOD = 'SET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIOD';
export const RESET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS = 'RESET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS';
